import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import {scrollToTop} from 'app/utils';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

const MOBILE_WIDTH = 480;
const MOBILE_MAX_VISIBLE = 6;
const MAX_VISIBLE = 9;

export default class Pagination extends PureComponent {
    static FIRST_PAGE = 1;

    get countPages() {
        return window.innerWidth <= MOBILE_WIDTH ? MOBILE_MAX_VISIBLE : MAX_VISIBLE;
    }

    changePage = (params) => {
        const {searchValue, switchPage} = this.props;

        if (searchValue) {
            switchPage(params, searchValue);
        } else {
            switchPage(params);
        }
        scrollToTop();
    };

    needsPagination = () => {
        return this.props.total_pages > 1;
    };

    nextPage = () => {
        const {current_page, total_pages} = this.props;

        if (current_page < total_pages) {
            this.changePage(this.queryParams(current_page + 1));
        }
    };

    previousPage = () => {
        const {current_page} = this.props;

        if (current_page > 1) {
            this.changePage(this.queryParams(current_page - 1));
        }
    };

    addFirstPageIfNeeded = (page, firstPage) => {
        if (!page.includes(firstPage)) {
            const secondPage = page[0];
            if (secondPage === firstPage + 2) {
                page.unshift(firstPage + 1);
            } else if (secondPage > firstPage + 2) {
                page.unshift(firstPage, '...');
            } else {
                page.unshift(firstPage);
            }
        }
    };

    addLastPageIfNeeded = (page, lastPage) => {
        if (!page.includes(lastPage)) {
            const secondLastPage = page[page.length - 1];
            if (secondLastPage === lastPage - 2) {
                page.push(lastPage - 1);
            } else if (secondLastPage < lastPage - 2) {
                page.push('...', lastPage);
            } else {
                page.push(lastPage);
            }
        }
    };

    enumeration = () => {
        const {current_page} = this.props;
        let maxVisible = this.countPages;
        const max = this.props.total_pages;
        let skip = 0;
        if (maxVisible > max) {
            maxVisible = max;
        } else if (current_page > maxVisible - 1 && current_page < max) {
            skip = current_page - maxVisible + 1;
        } else if (current_page === max) {
            skip = current_page - maxVisible;
        }

        const page = Array.from({length: maxVisible}, (_, i) => skip + i + 1);
        const firstPage = this.constructor.FIRST_PAGE;

        this.addFirstPageIfNeeded(page, firstPage);
        this.addLastPageIfNeeded(page, max);

        return page;
    };

    queryParams = (page) => {
        const validPage = page > this.props.total_pages ? this.props.total_pages : page;
        return {
            ...this.props.query || {},
            page: validPage || 1
        };
    };

    buildSearchString = (page) => {
        const params = this.queryParams(page);
        return `?${new URLSearchParams(params).toString()}`;
    };

    handlePageClick = (page) => (e) => {
        e.preventDefault();
        this.changePage(this.queryParams(page));
    };

    render = () => {
        if (!this.needsPagination()) {
            return null;
        }
        const {current_page, total_pages} = this.props;
        const prevSearch = this.buildSearchString(current_page - 1);
        const nextSearch = this.buildSearchString(current_page + 1);

        return <ul className="smart-pagination">
            <li className={current_page === 1 ? 'disabled' : null}>
                <Link to={{
                    pathname: window.location.pathname,
                    search: prevSearch
                }}
                onClick={this.previousPage}
                className="button-pagination prev"
                rel="prev">
                    <SpriteIcon name="#pag-arr-left" className="svg-default"/>
                </Link>
            </li>
            {this.enumeration().map((page, index) => typeof page === 'number'
                ? <li className={current_page === page ? 'active' : null} key={index}>
                    <Link to={{
                        pathname: window.location.pathname,
                        search: this.buildSearchString(page)
                    }}
                    onClick={this.handlePageClick(page)}
                    className="button-adaptive button-adaptive_instyle">{page}
                    </Link>
                </li>
                : <li key={index} className="disabled"><Link>{page}</Link></li>)}
            <li className={current_page === total_pages ? 'disabled' : null}>
                <Link to={{
                    pathname: window.location.pathname,
                    search: nextSearch
                }}
                onClick={this.nextPage}
                className="button-pagination next"
                rel="next">
                    <SpriteIcon name="#pag-arr-right" className="svg-default"/>
                </Link>
            </li>
        </ul>;
    };
}
